import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { updateRoute } from '_Resources/Header/Actions/updateRoute';
import { connect } from 'react-redux';
import '../../../../node_modules/react-resizable/css/styles.css';
import '../../../../node_modules/react-grid-layout/css/styles.css';
import { getRoute } from '_Utils/routes/routeUtils';
import LandingPageCard from '_Cards/LandingPageCard/LandingPageCard';
import QToast from '_Components/QToast/QToast';
import { lightBlue } from '../../../styles/abstracts/colors';
import ProjectListCard from './_Components/ProjectListCard/ProjectListCard';
import TipsAndTricksCard from './_Components/TipsAndTricksCard/TipsAndTricksCard';
import { getHeaderTopHeight } from '../../../_Layouts/Header/_Utils/HeaderUtils';

const MainPage = ({ dispatchUpdateRoute, currentUser, subHeaderRef, editableLayout, collapsedInfo, toastMessage }) => {
  const [headerHeight, setHeaderHeight] = useState(
    subHeaderRef.current?.getBoundingClientRect().height + getHeaderTopHeight(),
  );

  useEffect(() => {
    getRoute(dispatchUpdateRoute, 'main');
    setTimeout(() => {
      setHeaderHeight(subHeaderRef.current?.getBoundingClientRect().height + getHeaderTopHeight());
    }, 200);
  }, [collapsedInfo]);

  return (
    <div>
      <Container fluid className="py-3 px-4">
        <LandingPageCard headerHeight={headerHeight} />
        {toastMessage && toastMessage.length > 0 && <QToast color={lightBlue}>{toastMessage}</QToast>}
        <ProjectListCard
          currentUser={currentUser}
          title="Your projects"
          titleSecondPart=""
          displayCardSubTitle={false}
          dropDownOptions={['EXPORT', 'PROJECT_SETTINGS']}
          className="mb-4"
          headerHeight={headerHeight}
        />
        <TipsAndTricksCard
          title="Video tutorials"
          titleSecondPart=""
          displayCardSubTitle={false}
          dropDownOptions={['EXPORT']}
          style={{
            height: 'auto',
            paddingBottom: '2em',
          }}
        />
      </Container>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    list_projects: state.projects.projectsList,
    editableLayout: state.routes.activeLayoutEdition,
    module: state.routes.route && state.routes.route.name,
    currentUser: state.auth && state.auth.user,
    collapsedInfo: state.projectConfiguration.collapsedInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchUpdateRoute: newState => {
      dispatch(updateRoute(newState));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
